import React, { Component, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';
import classNames from 'classnames';


const JobsPageItem = ({ showJob, setShowJob, image, job, JobComponent, setJob, jobType, title, intro, button, ...props}) => {


  const clickJob = (values) => {
    setShowJob(!showJob)
    setJob(!showJob ? jobType : "")
  }

  return (
    <>
      {showJob ?
        (<>
          {
            job == jobType &&
            <>
              <JobComponent
                setShowJob={setShowJob}
                showJob={showJob}
                job={job}
              />
            </>
          }</>)
        : (<>
          <div className="event-list-item-container col-xs-8 col-sm-4">
            <div onClick={clickJob}>
              <div className="container-960 container-full-width">
                <div className="row">
                  <div
                    className="event-list-item-container-inner"
                    onClick={clickJob}
                  >
                    <div
                      className={classNames('event-list-item-banner', {
                        'banner-gray-scale': false,
                      })}
                    >
                      <img src={image} alt="" />
                    </div>
                    <div className="event-list-item-body">
                      <b className="event-list-item-name">
                        {title}
                      </b><br/>
                      {intro}
                    </div>
                    <div className={classNames('event-list-item-footer', 'event-list-item-footer-action')}>
                      <button className="redirect" onClick={clickJob}>
                        {button}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>)}
      
    </>
  );
}

export default JobsPageItem;